import React from 'react';

import { useAppStore } from 'src/hooks/useAppStore';
import * as customStyled from './styles';

const WatchButtonMedium: React.FC<any> = ({ watchCallback }) => {
  const { translations } = useAppStore();
  return (
    <div
      data-testid="watch-btn"
      css={customStyled.watchButton}
      onClick={watchCallback}
      title={translations?.consumption?.WATCH_BUTTON_TEXT}>
      <span>{translations?.consumption?.WATCH_BUTTON_TEXT}</span>
    </div>
  );
};

export default WatchButtonMedium;
